import { Clinic, Invitation, Vet, VetUser } from '@app/core/models';
import { FeatureToggles } from '@app/core/models/feature-toggles';
import { Market } from '@app/core/models/market';
import { RecoConsent } from '@app/core/models/reco-consent';
import { MeasurementCodeType } from '@app/shared/utils';
import { CountryCode } from '@app/shared/utils/enums/country-code.enum';
import { SystemPreferenceCode } from '@app/shared/utils/enums/system-preference-code';
import { createAction, props } from '@ngrx/store';
import { UserClaims } from '@okta/okta-auth-js';

/**
 * Set vet action
 * Should only be used in RegisterConnectComponent
 * Deprecated, will be removed
 */
export const setVet = createAction('[Vet] Set Vet', props<{ vet: Vet }>());

/**
 * Actions to update vet
 */
export const updateVet = createAction('[Vet] Update Vet', props<{ vet: Vet; reload?: boolean }>());
export const updateVetSuccess = createAction('[Vet] Update Vet Success', props<{ vet: Vet }>());
export const updateVetFail = createAction('[Vet] Update Vet Fail', props<{ errorMessage: string }>());

/**
 * Actions to update vet user
 */
export const updateVetUser = createAction('[Vet] Update VetUser', props<{ oktaId: string; vetUser: VetUser }>());
export const updateVetUserSuccess = createAction('[Vet] Update VetUser Success', props<{ vetUser: VetUser }>());
export const updateVetUserFail = createAction('[Vet] Update VetUser Fail', props<{ errorMessage: string }>());

export const setCurrentClinicId = createAction('[Vet] Set Current Clinic Id', props<{ clinicId: string }>());

/**
 * Get vet actions
 */
/**
 * Action to load vet
 */
export const getVet = createAction('[Vet] Get Vet');
/**
 * Action dispatched when vet has been found
 */
export const getVetSuccess = createAction(
  '[Vet] Get Vet Success',
  props<{ vet: Vet; currentClinic: Clinic | undefined; oktaUser: UserClaims }>(),
);
/**
 * Action dispatched on error (including new vet not found)
 */
export const getVetFail = createAction('[Vet] Get Vet Fail');

/**
 * Action to set vet validity
 * See vet.effects for criteria
 */
export const setVetValidity = createAction('[Vet] Get Vet Valid', props<{ value: boolean }>());

/**
 * Set invitation action
 */
export const setInvitation = createAction('[Vet] Get Set Invitation', props<{ invitation: Invitation | undefined }>());

/**
 * Actions to load market data
 */
export const getMarket = createAction('[Vet] Get Market', props<{ countryCode: CountryCode }>());
export const getMarketSuccess = createAction('[Vet] Get Market Success', props<{ market: Market }>());
export const getMarketFail = createAction('[Vet] Get Market Fail', props<{ error: string }>());

/**
 * Actions to load reco consent data
 */
export const getRecoConsentData = createAction('[Vet] Get Reco Consent Data', props<{ countryCode: CountryCode }>());
export const getRecoConsentDataSuccess = createAction(
  '[Vet] Get Reco Consent Data Success',
  props<{ recoConsent: RecoConsent; countryCode: CountryCode }>(),
);
export const getRecoConsentDataFail = createAction('[Vet] Get Reco Consent Data Fail', props<{ error: string }>());

/**
 * Actions to load feature toggles data
 */
export const getFeatureTogglesData = createAction(
  '[Vet] Get Feature Toggles Data',
  props<{ customerId: string; countryCode: CountryCode }>(),
);
export const getFeatureTogglesDataSuccess = createAction(
  '[Vet] Get Feature Toggles Data Success',
  props<{ featureToggles: FeatureToggles; customerId: string; countryCode: CountryCode }>(),
);
export const getFeatureTogglesDataFail = createAction('[Vet] Get Feature Toggles Data Fail', props<{ error: string }>());

/**
 * Action to update clinic
 */
export const updateClinic = createAction(
  '[Vet] Update Clinic',
  props<{ clinicId: string; clinic: Partial<Clinic>; redirectTo?: string[] }>(),
);
export const updateClinicSuccess = createAction('[Vet] Update Clinic Success', props<{ clinic: Clinic }>());

export const displayInfoPopin = createAction('[Vet] Display Info Popin');
export const setInfoPopin = createAction('[Vet] Set Info Popin', props<{ clinic: Clinic; market: Market; vet: Vet }>());
export const setInfoAlert = createAction('[Vet] Set Info Alert', props<{ clinic: Clinic; market: Market; vet: Vet }>());

export const setPreferredMaxPetWeight = createAction('[Vet] Set Preferred Max Pet Weight', props<{ weight: number }>());

export const setCurrentBigMeasurementUnit = createAction('[Vet] Set Current Big Measurement Unit', props<{ unit: MeasurementCodeType }>());
export const setCurrentSmallMeasurementUnit = createAction(
  '[Vet] Set Current Small Measurement Unit',
  props<{ unit: MeasurementCodeType }>(),
);
export const setCurrentSystemPreferenceCode = createAction(
  '[Vet] Set Current System Preference Code',
  props<{ systemPreferenceCode: SystemPreferenceCode }>(),
);
